import React, { ReactNode } from 'react';
import { Typography, Tooltip } from '@mui/material';
import { Column } from 'components/shared/TableListing/types';
import { CalendarToday, Person, SwapHoriz, Description } from '@mui/icons-material';

import { ChangeTypeChip } from './cells';
import { ChangelogTableRow } from './types';

export const getChangelogListingColumns = (
  changesCell: (row: ChangelogTableRow) => ReactNode
): Column<ChangelogTableRow>[] => [
  {
    width: '11rem',
    header: 'Date time',
    renderKey: 'createdDateTime',
    headerStyles: {
      minHeight: 'auto',
    },
    startIcon: (
      <Tooltip arrow placement="top" title="Date when change was made">
        <CalendarToday fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { createdDateTime } }) => <Typography>{createdDateTime}</Typography>,
  },
  {
    width: '16rem',
    header: 'Change Type',
    renderKey: 'changeType',
    headerStyles: {
      minHeight: 'auto',
    },
    startIcon: (
      <Tooltip arrow placement="top" title="Type of change">
        <SwapHoriz fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { changeType } }) => <ChangeTypeChip changeType={changeType} />,
  },
  {
    width: '12rem',
    header: 'Modified By',
    renderKey: 'modifiedBy',
    headerStyles: {
      minHeight: 'auto',
    },
    startIcon: (
      <Tooltip arrow placement="top" title="Person who made changes">
        <Person fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row: { modifiedBy } }) => <Typography>{modifiedBy}</Typography>,
  },
  {
    header: 'Changes',
    renderKey: 'changes',
    headerStyles: {
      minHeight: 'auto',
    },
    startIcon: (
      <Tooltip arrow placement="top" title="Change details">
        <Description fontSize="small" color="primary" />
      </Tooltip>
    ),
    renderCell: ({ row }) => changesCell(row),
  },
];
